









































import { Button } from 'vant';
import VoteButton from '@/components/VoteButton/index.vue';
import VoteButtonNext from '@/components/next/VoteButton.vue';
import { Vue, Component } from 'vue-property-decorator';
import Prism from 'prismjs';
import qs from 'qs';
import {
  getBaseinfo,
  getRules,
  getVoteList,
  getNewslist,
  vote,
} from '@/api/api';
import * as config from '../config';
Vue.use(Button);
@Component({
  components: {
    VoteButton,
    VoteButtonNext,
  },
})
export default class ApiDemo extends Vue {
  options = config.OPTHINES;
  async mounted() {
    Prism.highlightAll();
    // const resBaseinfo = await getBaseinfo(this.options.voteName);
    // console.log('resBaseinfo', resBaseinfo);
    // const resRules = await getRules(this.options.voteName);
    // console.log('resRules', resRules);
    // const resNewsList = await getNewslist(this.options.voteName, 1);
  }
  onVoteSuccess(res: any) {
    console.log(res);
  }
}
